import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import logo from '../../assets/justservicelogo.png';
import './Footer.css';

function ComingSoonPopup({ onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, 2500);
    return () => clearTimeout(t);
  }, [onClose]);
  return (
    <div className="cs-overlay" onClick={onClose}>
      <div className="cs-popup" onClick={e => e.stopPropagation()}>
        <div className="cs-icon">🚀</div>
        <h3>Coming Soon!</h3>
        <p>Our app is launching soon on<br />Google Play &amp; App Store.</p>
        <div className="cs-bar"><div className="cs-bar-fill" /></div>
      </div>
    </div>
  );
}

export default function Footer() {
  const [showStorePop, setShowStorePop] = useState(false);
  return (
    <footer className="footer">
      <div className="container">
        {/* Logo */}
        <div className="footer-logo-wrap">
          <img src={logo} alt="JustService24" className="footer-logo-img" />
          <div>
            <div className="footer-brand-name">Just<span>Service24</span></div>
            <div className="footer-brand-tag">Your Local Business Directory</div>
          </div>
        </div>

        {/* 6-column grid */}
        <div className="footer-grid">
          <div className="footer-col">
            <h4>Support</h4>
            <p>Mon - Sat</p>
            <p>10:00 AM - 6:00 PM</p>
            <a href="mailto:support@justservice24.com">support@justservice24.com</a>
          </div>

          <div className="footer-col">
            <h4>Useful Links</h4>
            <Link to="/">Home</Link>
            <Link to="/categories/business">Business Listing</Link>
            <a href="#">Blog</a>
            <a href="#">About Us</a>
            <Link to="/support">Support</Link>
            <a href="#">Contact</a>
          </div>

          <div className="footer-col">
            <h4>Business</h4>
            <Link to="/add-business">Add Business</Link>
            <a href="#">Modify Business</a>
          </div>

          <div className="footer-col">
            <h4>Get Support</h4>
            <a href="#">For Business</a>
            <a href="#">For User</a>
            <a href="#">For Staff</a>
            <a href="#">FAQ</a>
          </div>

          <div className="footer-col">
            <h4>Policies</h4>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-conditions">Terms &amp; Conditions</Link>
            <Link to="/cancellation-refund">Cancellation &amp; Refund</Link>
          </div>

          <div className="footer-col">
            <h4>Follow Us</h4>
            <div className="footer-social">
              <a href="#" className="social-icon" aria-label="Facebook"><FaFacebookF /></a>
              <a href="#" className="social-icon" aria-label="Instagram"><FaInstagram /></a>
              <a href="#" className="social-icon" aria-label="LinkedIn"><FaLinkedinIn /></a>
              <a href="#" className="social-icon" aria-label="YouTube"><FaYoutube /></a>
            </div>
            <div className="footer-store-btns">
              <a href="#" className="footer-store-btn" onClick={e => { e.preventDefault(); setShowStorePop(true); }}>
                <svg viewBox="0 0 24 24" className="store-svg" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.18 23.76c.3.17.65.19.97.07l11.65-11.65L12 8.38 3.18 23.76z" fill="#EA4335"/>
                  <path d="M20.82 10.53l-2.6-1.5-3.24 3.24 3.24 3.24 2.62-1.51a1.49 1.49 0 0 0 0-2.6-.13-.07-.02-.07-.02z" fill="#FBBC04"/>
                  <path d="M3.18.24A1.49 1.49 0 0 0 2.5 1.5v21a1.49 1.49 0 0 0 .68 1.26L15.82 12 3.18.24z" fill="#4285F4"/>
                  <path d="M3.18 23.76 15.82 12 12 8.18.24z" fill="#34A853"/>
                </svg>
                <div>
                  <small>GET IT ON</small>
                  <strong>Google Play</strong>
                </div>
              </a>
              <a href="#" className="footer-store-btn" onClick={e => { e.preventDefault(); setShowStorePop(true); }}>
                <svg viewBox="0 0 24 24" className="store-svg" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.37 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" fill="#fff"/>
                </svg>
                <div>
                  <small>Download on the</small>
                  <strong>App Store</strong>
                </div>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2024 JustService24. All rights reserved. | Onexvora Business Solutions</p>
        </div>
      </div>
      {showStorePop && <ComingSoonPopup onClose={() => setShowStorePop(false)} />}
    </footer>
  );
}
